// extracted by mini-css-extract-plugin
export default {"item_container":"List_item_container__HhIPC","name":"List_name__33x8k","price":"List_price__UKsqm","icon":"List_icon__e4O+v"};